import App from './App.svelte';

const app = new App({
	target: document.getElementById('myapp'),
	props: {}
});

export default app;